module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic13.fd0e9bff.png";